import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@material-ui/core';
import React from 'react';

import { IModel } from '~/src/dash/components/model';
import { Span } from '~/src/dash/publicaUI';
import { IWithStylesProps } from '~/src/dash/types/props';
import { publicaColors } from '~/src/dash/utils/colors';
import { decorate } from '~/src/dash/utils/decorator';
import { SnackbarView } from '~/src/dash/views/snackbar-view';

export interface IModelDialogDeleteProps extends IWithStylesProps, IModel {
  active: boolean;
  deleteModel: (modelID: string, idx?: number) => Promise<any>;
  model: string;
  idx?: number;
  onClose?: (modelID: string) => void;
  onError?: (modelID: string) => void;
  onDelete?: (modelID: string, idx?: number) => void;
  disableSnackbar?: boolean;
  customMessage?: string;
  title?: string;
  confirmationMessage?: string;
  confirmMessageWithItemName?: string;
}

interface IState {
  deleting: boolean;
  snackbar: boolean;
  err: boolean;
}

export const ModelWithTitleConfirmation = decorate(
  {
    styles: (theme: any) => ({
      icon: {
        fontSize: '1rem',
        marginRight: '1rem',
      },
      error: {
        backgroundColor: theme.palette.error.dark,
      },
      message: {
        display: 'inline-flex',
        'align-items': 'center',
      },
    }),
  },
  class extends React.Component<IModelDialogDeleteProps, IState> {
    state = {
      deleting: false,
      snackbar: false,
      err: false,
    };

    onClose = () => {
      if (this.props.onClose) {
        this.props.onClose(this.props.ID);
      }
      this.setState({
        err: false,
      });
    };

    onError = () => {
      if (this.props.onError) {
        this.props.onError(this.props.ID);
      }
      this.setState({
        deleting: false,
        snackbar: true,
        err: true,
      });
    };

    onDelete = () => {
      if (this.props.onDelete) {
        this.props.onDelete(this.props.ID, this.props.idx);
      }
      this.setState({
        deleting: false,
        snackbar: true,
        err: false,
      });
    };

    onCloseSnackbar = () => {
      this.setState({
        snackbar: false,
      });
    };

    deleteModel = () => {
      this.setState({
        snackbar: false,
        deleting: true,
      });
      this.props.deleteModel(this.props.ID, this.props.idx).then(this.onDelete, this.onError);
    };

    componentDidUpdate(prevProps: IModelDialogDeleteProps) {
      if (prevProps.ID !== this.props.ID) {
        this.setState({
          err: false,
        });
      }
    }

    render() {
      return (
        <div>
          <Dialog
            open={this.props.active}
            onClose={this.onClose}
            disableBackdropClick={this.state.deleting}
            disableEscapeKeyDown={this.state.deleting}
            aria-labelledby='alert-dialog-title'
            aria-describedby='alert-dialog-description'
          >
            <DialogTitle>{this.props.title}?</DialogTitle>
            <DialogContent>
              {this.props.customMessage && (
                <DialogContentText>
                  <Span color={publicaColors.black}>{this.props.customMessage}</Span>
                </DialogContentText>
              )}
              <DialogContentText id='alert-dialog-description'>
                <Span color={publicaColors.black} bold>
                  {this.props.confirmationMessage}
                </Span>
              </DialogContentText>
              {this.props.confirmMessageWithItemName && (
                <DialogContentText
                  id='alert-dialog-description'
                  style={{ color: publicaColors.black, fontWeight: '500' }}
                >
                  Should{' '}
                  <Span bold highlighted>
                    {this.props.confirmMessageWithItemName}
                  </Span>{' '}
                  be removed?
                </DialogContentText>
              )}
            </DialogContent>
            <DialogActions>
              <Button onClick={this.deleteModel} disabled={this.state.deleting}>
                <Span highlighted bold>
                  Confirm
                </Span>
                <span style={this.state.deleting ? { opacity: 1 } : { opacity: 0 }}>
                  &nbsp;
                  <CircularProgress size={12} />
                </span>
              </Button>
              <Button onClick={this.onClose} autoFocus disabled={this.state.deleting}>
                Cancel
              </Button>
            </DialogActions>
          </Dialog>
          {!this.props.disableSnackbar && (
            <SnackbarView
              open={this.state.snackbar}
              error={this.state.err}
              onClose={this.onCloseSnackbar}
            >
              {this.state.err
                ? `Failed to delete ${this.props.model}: [${this.props.ID}] ${this.props.Name}`
                : `Deleted ${this.props.model}: [${this.props.ID}] ${this.props.Name}`}
            </SnackbarView>
          )}
        </div>
      );
    }
  },
);
